import { useQuery } from '@tanstack/react-query'
import EcommerceContactsApi from '@/infrastructure/api/ecommerce-contacts'
import { groupOfStore } from '@/domain/store-group'
import { useAppSelector } from '@/redux/hooks'

const ECOMMERCE_CONTACTS_KEY = ['ecommerceContacts']

export function contactsKey(group?: string) {
  return [...ECOMMERCE_CONTACTS_KEY, group]
}

// Contacts are kept per group: every store of the group shares them.
export function useContactsGroup(ecommerceId?: string) {
  const user = useAppSelector((s) => s.userApi.getMe.response.user)
  return ecommerceId ? groupOfStore(user, ecommerceId) : undefined
}

export function useEcommerceContacts({
  enabled,
  group
}: {
  enabled: boolean
  group?: string
}) {
  const query = useQuery({
    queryKey: contactsKey(group),
    queryFn: ({ signal }) =>
      EcommerceContactsApi.getGroupContacts(group ?? '', signal),
    enabled: enabled && !!group
  })

  return {
    contacts: query.data ?? [],
    loadingContacts: query.isLoading,
    contactsError: query.isError,
    reloadContacts: query.refetch
  }
}
